export default __webpack_public_path__ + "static/media/Mail.a385a6bb.svg";